<template>
    <svg
        id="icon_menu_password"
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="25"
        viewBox="0 0 19 25"
    >
        <path
            id="Subtraction_9"
            data-name="Subtraction 9"
            d="M2239-1750.772h-13a3,3,0,0,1-3-3v-8a3,3,0,0,1,3-3h13a3,3,0,0,1,3,3v8A3,3,0,0,1,2239-1750.772Zm-6.5-12a4.505,4.505,0,0,0-4.5,4.5,4.505,4.505,0,0,0,4.5,4.5,4.505,4.505,0,0,0,4.5-4.5A4.505,4.505,0,0,0,2232.5-1762.771Z"
            transform="translate(-2223 1775.771)"
            fill="#fff"
        />
        <g
            id="Rectangle_188"
            data-name="Rectangle 188"
            transform="translate(3)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
        >
            <path
                d="M6.5,0h0A6.5,6.5,0,0,1,13,6.5V13a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6.5A6.5,6.5,0,0,1,6.5,0Z"
                stroke="none"
            />
            <path
                d="M6.5,1h0A5.5,5.5,0,0,1,12,6.5V12a0,0,0,0,1,0,0H1a0,0,0,0,1,0,0V6.5A5.5,5.5,0,0,1,6.5,1Z"
                fill="none"
            />
        </g>
        <circle
            id="Ellipse_44"
            data-name="Ellipse 44"
            cx="2.5"
            cy="2.5"
            r="2.5"
            transform="translate(7 15)"
            fill="#fff"
        />
    </svg>
</template>
